import store from "@/redux/store"; // Adjust the path to your Redux store
import { getForgeRockAuthInfo, getForgeRockToken } from "@/redux/dataSlice";


export const getUserSfId = async () => {
  const state = store.getState();
  const userInfo = getForgeRockAuthInfo(state);
  return userInfo?.educationId ?? null;
};

export const getUserDetails = () => {
  const state = store.getState();
  const userInfo = getForgeRockAuthInfo(state);
  return userInfo ?? null;
};

export const getUserToken = () => {
  const state = store.getState();
  const userToken = getForgeRockToken(state);
  return userToken?.accessToken ?? null;
};

